import DomainCommon from './common'

const FeedbackService = {
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/feedback`,
                resolve, reject,
            })
        })
    },
    reply: ({ feedbackId, replyContent }) => {
        return new Promise(((resolve, reject) => {
            return DomainCommon.fetchPost({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/feedback/${feedbackId}/reply`,
                jsonBody: { reply_content: replyContent },
                resolve, reject,
            })
        }))
    },
}

export default FeedbackService



// WEBPACK FOOTER //
// ./src/service/feedback.js